import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateBoxCertificateDialogComponent } from '../create-box-certificate-dialog/create-box-certificate-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { map, switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { CompaniesService } from "../../../services/companies.service";
import { BoxCertificate } from "../../../model/box-certificate";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { Router } from "@angular/router";
import { BoxCertificatesService } from "../../../services/box-certificates.service";
import { Constants } from "../../../utils/constants";
import { Box } from "../../../model/box";
import { merge } from "lodash-es";

@Component({
  selector: 'aw-list-box-certificates',
  templateUrl: './list-box-certificates.component.html',
  styleUrls: ['./list-box-certificates.component.scss']
})
export class ListBoxCertificatesComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'creationDate',
    'endDate',
    'revokeDate',
    'box',
    'cmId',
    'status',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorBoxCertificates') paginatorUsers!: MatPaginator;
  @Input() embeddedLayout = false;
  @Input() box?: Box;
  dataSource!: MatTableDataSource<BoxCertificate>;
  private allBoxCertificates$!: Observable<BoxCertificate[]>;
  roles = Constants.roles;
  entities = Constants.entities;
  certificatesStatuses = Constants.certificateStatuses;
  boxStatuses = Constants.boxStatuses;

  constructor(
    public dialog: MatDialog,
    private companiesService: CompaniesService,
    private boxCertificatesService: BoxCertificatesService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.allBoxCertificates$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (this.box) {
              this.box.currentCertificate = this.box.boxCertificates?.find(boxCertificate => boxCertificate.status === this.certificatesStatuses.assigned);
              return this.boxCertificatesService.getBoxCertificate(this.box.currentCertificate?.id).pipe(map(value => [value]));
            }
            return this.boxCertificatesService.getAllBoxCertificates();
          }),
          tap(x => {
            this.dataSource = new MatTableDataSource<BoxCertificate>(x);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allBoxCertificates$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortBoxCertificates(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      const index: string = event.active;

      if (event.active === 'box') {
        if (event.direction === 'asc') {
          return ('' + b.box?.identifier).localeCompare('' + a.box?.identifier);
        } else {
          return ('' + a.box?.identifier).localeCompare('' + b.box?.identifier);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(certificate: BoxCertificate): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: certificate });
  }

  createBoxCertificate(): void {
    this.disabled = true;
    this.dialog
      .open(CreateBoxCertificateDialogComponent, { data: new BoxCertificate() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxCertificates$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
          this.snackService.success('Box certificate created!');
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editBoxCertificate(certificate: BoxCertificate): void {
    this.disabled = false;
    this.dialog
      .open(CreateBoxCertificateDialogComponent, { data: certificate })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxCertificates$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
          this.snackService.success('Box certificate updated!');
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteBoxCertificate(boxCertificate: BoxCertificate): void {
    this.disabled = true;
    const id = boxCertificate.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete certificate', `Are you sure you want to delete the certificate "${boxCertificate.cmId}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxCertificatesService.deleteBoxCertificate(<number>boxCertificate.id) :
          EMPTY),
        switchMap(() => this.allBoxCertificates$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Box certificate deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }


  revokeBoxCertificate(boxCertificate: BoxCertificate): void {
    this.disabled = true;
    const editedBoxCertificate = merge(new BoxCertificate(), boxCertificate);
    editedBoxCertificate.status = this.certificatesStatuses.revoked;
    this.dialogsService
      .confirm('Revoke certificate', `Are you sure you want to revoke the certificate "${boxCertificate.cmId}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxCertificatesService.updateBoxCertificate(editedBoxCertificate) :
          EMPTY),
        switchMap(() => this.allBoxCertificates$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Box certificate revoked!');
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
      },
        () => {
          this.disabled = false;
        });

  }
}
